import '@fontsource-variable/inter-tight';
import '@fontsource-variable/source-serif-4';
import '@fontsource/jetbrains-mono';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';

import { App } from './App';
import { GlobalStyles } from './theme/global';
import { theme } from './theme/tokens';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing');

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </StrictMode>,
);
